import { Injectable } from "@angular/core";
import Api from "app/helpers/api";
import { take } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})

export class CityService {
  constructor(private api: Api) {}

  apiCall = this.api.new().silent();

  /**
   * Fetchess employee data by company
   */
  getCidades(params: any = {}) {
    console.log("Iniciando chamada à API de Cidades...");
   return this.apiCall.get('municipios',  params ).pipe(take(1)).toPromise()
  }

  getCidadeById(params: any = {}) {
    console.log("Iniciando chamada à API de Cidades...");
   return this.apiCall.get('municipios/by-id',  params ).pipe(take(1)).toPromise()
  }
  
  getTotalCidades(params) {
    console.log("Iniciando chamada à API de Cidades...");
   return this.apiCall.get('municipios/count',  params ).pipe(take(1)).toPromise()
  }

  async cadastrarCidadeCliente(data: {}){
    console.log("Iniciando chamada à API de Cidades...");
    const request = await this.apiCall.post('municipios', data).pipe(take(1)).toPromise();
    console.log(request)
    return request;
  }
 
}